import { CONFIG } from 'src/global-config';

// ----------------------------------------------------------------------

export async function handleShare(path) {
  try {
    if (!navigator.share) throw new Error('Share not supported by your browser');
    await navigator.share({ url: `${CONFIG.appDomain}${path}` });
  } catch (error) {
    console.error('Error sharing:', error);
  }
}
